import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

        return	<section className="service-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/effortless-integration.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Effortless Setup & Integration</h3>
                            <p>Integrating Converzex.ai into your business is fast, simple, and hassle-free. Our AI Chat Agent and voice solutions are designed to seamlessly connect with your website, CRM, or existing business systems without disrupting your workflow. Whether you're using a custom platform or third-party tools, our flexible integration process ensures smooth deployment with minimal technical effort.</p>
                            <p>From lead capture to customer engagement, everything works together in real time, allowing your team to manage conversations, track leads, and automate communication from one centralized platform. With quick setup, scalable architecture, and user-friendly configuration, you can start generating value from day one.</p>

                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}

            </div>{/* /.container */}
        </section>

    }
}

export default ServiceDetails